import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import { useEffect, useState } from "react";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

const LongitudeInput = ({ value, onChange, precision, disabled }) => {
    const [inputValue, setInputValue] = useState(value || "");
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const onLongitudeChange = (event) => {
        const rawInput = event.target.value;
        setInputValue(rawInput);
        onChange(rawInput);
    };

    const onBlur = () => {
        const trimmedInput = inputValue.trim();

        if (!trimmedInput) {
            return;
        }

        const parsedLong = parseFloat(trimmedInput);
        if (isFinite(parsedLong) && !isNaN(parsedLong) && parsedLong >= -180 && parsedLong <= 180) {
            const formattedValue = parsedLong.toFixed(precision);
            setInputValue(formattedValue);
            onChange(formattedValue);
        }
    };

    return <Input value={inputValue} onChange={onLongitudeChange} onBlur={onBlur} placeholder={`Enter longitude (e.g., -74.0060)`} disabled={disabled} />;
};

function FormLongitudeField({ fieldErrors, fieldId, name, description, isRequired, precision, disabled = false, ...field }) {
    const validateLongitude = (_, value) => {
        if (!value || !value.trim()) {
            return Promise.resolve();
        }
        const trimmedValue = value.trim();
        const parsedLong = parseFloat(trimmedValue);

        if (isNaN(parsedLong)) {
            return Promise.reject("Longitude must be a numeric value");
        }
        if (parsedLong < -180 || parsedLong > 180) {
            return Promise.reject("Longitude must be between -180 and 180 degrees");
        }

        return Promise.resolve();
    };

    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={[]} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {disabled && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            rules={[
                {
                    required: isRequired,
                    message: "Longitude is required",
                },
                {
                    validator: validateLongitude,
                },
            ]}
            {...fieldErrors}
        >
            <LongitudeInput precision={precision} disabled={disabled} />
        </Form.Item>
    );
}

export default FormLongitudeField;
